module.exports = __webpack_public_path__ + "PG.png?f435b0c2ca5b82264d45deef26fd84c8";